function moveFasletButton(fasletElement) {
  if (!fasletElement) {
    console.error('Faslet container not found');
    return;
  }

  const target = document.querySelector('.add-to-cart__sizes-container label');

  if (!target) {
    console.error('Target element not found');
    return;
  }

  target.appendChild(fasletElement);
}

// Events

$(document).ready(() => {
  waitForElement('faslet-app', (element) => {
    moveFasletButton(element);
  });
});
